
    import './styles.scoped.css';
    export default {
  "icon-shake": "awsui_icon-shake_1cbgc_1af4s_145",
  "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_1cbgc_1af4s_1",
  "container-fade-in": "awsui_container-fade-in_1cbgc_1af4s_173",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1cbgc_1af4s_1",
  "root": "awsui_root_1cbgc_1af4s_195",
  "status-error": "awsui_status-error_1cbgc_1af4s_204",
  "status-warning": "awsui_status-warning_1cbgc_1af4s_207",
  "status-success": "awsui_status-success_1cbgc_1af4s_210",
  "status-info": "awsui_status-info_1cbgc_1af4s_213",
  "status-stopped": "awsui_status-stopped_1cbgc_1af4s_216",
  "status-pending": "awsui_status-pending_1cbgc_1af4s_219",
  "status-in-progress": "awsui_status-in-progress_1cbgc_1af4s_222",
  "status-loading": "awsui_status-loading_1cbgc_1af4s_225",
  "color-override-red": "awsui_color-override-red_1cbgc_1af4s_228",
  "color-override-grey": "awsui_color-override-grey_1cbgc_1af4s_231",
  "color-override-blue": "awsui_color-override-blue_1cbgc_1af4s_234",
  "color-override-green": "awsui_color-override-green_1cbgc_1af4s_237",
  "color-override-yellow": "awsui_color-override-yellow_1cbgc_1af4s_240",
  "container": "awsui_container_1cbgc_1af4s_173",
  "display-inline": "awsui_display-inline_1cbgc_1af4s_244",
  "icon": "awsui_icon_1cbgc_1af4s_145",
  "display-inline-block": "awsui_display-inline-block_1cbgc_1af4s_252",
  "overflow-ellipsis": "awsui_overflow-ellipsis_1cbgc_1af4s_261"
};
  